import { takeLatest, put, call } from 'redux-saga/effects';
import SectionWiseFetchDetailsTypes from './SectionWiseFetchDetails.types';
import { fetchDateWiseSectionAttendanceData } from './SectionWiseFetchDetails.services';
import { sectionWiseFetchSuccess, sectionWiseFetchFailure } from './SectionWiseFetchDetails.action';
import AlertManager from '../../utils/alertManager';
import { encryptData } from '../_common/enode-decode';

export function* fetchSectionWiseDataSaga(payload: any) {
	try {
		const { getMethod } = payload.payload;

		// const key = 'fetchSectionWiseKey';
		const key: any =
			getMethod === 'Branches'
				? 'fetchBranchWiseDataKey'
				: getMethod === 'Head Office'
					? 'fetchSectionWiseKey'
					: null;
		const encryptedData = encryptData(payload.payload, key);

		const datas =
			getMethod === 'Branches'
				? 'Branches'
				: getMethod === 'Head Office'
					? 'Head Office'
					: null;
		// @ts-ignore
		const responseData = yield call(
			fetchDateWiseSectionAttendanceData as any,
			encryptedData,
			datas,
		);
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else {
			if (responseData.data.status === 'error') {
				console.log('Received failure response');
				yield put(sectionWiseFetchFailure(responseData.data));
			} else {
				console.log('Received success response');
				yield put(sectionWiseFetchSuccess(responseData.data));
			}
		}
	} catch (error: any) {
		console.error('Error in fetchSectionWiseData:', error);
		yield put(sectionWiseFetchFailure(error?.response?.data?.message || 'An error occurred'));
	}
}

export function* onSectionWiseFetchStart(): Generator<any, void, any> {
	yield takeLatest(
		SectionWiseFetchDetailsTypes.SECTION_WISE_FETCH_START as any,
		fetchSectionWiseDataSaga,
	);
}

export function* sectionWiseFetchDetailsSaga(): Generator<any, void, any> {
	yield call(onSectionWiseFetchStart);
}
